import { Button, Message } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import ViewHippoInformationModal from '../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { isAccCoverableForOtherPerson, shouldShowUvpWarning } from '../../../utils/coverablesUtil';
import type { PrhCommonDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/prh';
import { LOB_CODE } from '../../../constants/coverable';

const SpinOffMessage = ({
    coverable,
    title = '',
    message,
    showAccidentModal = false
}: {
    coverable: CoverableDTO;
    title?: string;
    message: string;
    showAccidentModal?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const showAccidentSpinOffMessage = isAccCoverableForOtherPerson(coverable);
    const showCaravanSpinOffMessage = shouldShowUvpWarning(coverable);
    const accidentModalText = {
        title: getHippoText('DSS-ACCIDENT-SPIN-OFF-MESSAGE-HEADER'),
        description: getHippoText(
            'DSS-COVERABLE-INFORMATION-STEP-ORDER-FOR-EXPLANATION-MODAL-SUBHEADER'
        )
    };
    const isHouseWithNoUWI =
        coverable.lobCode === LOB_CODE.PRIVATE_HOUSE && !(coverable as PrhCommonDTO).hasUWI;

    const [showModal, setShowModal] = useState(false);

    if (!coverable.willSpinOff || isHouseWithNoUWI) {
        return <></>;
    }

    let content;

    if (showAccidentSpinOffMessage) {
        content = (
            <Message theme="warning">
                {message}
                {showAccidentModal && (
                    <>
                        {' '}
                        <Button
                            className="flos-button"
                            theme="ghost"
                            onClick={(): void => {
                                setShowModal(true);
                            }}
                        >
                            Læs mere her.
                        </Button>
                        <ViewHippoInformationModal
                            closeModal={() => {
                                setShowModal(false);
                            }}
                            showModal={showModal}
                            modalProps={accidentModalText}
                        />
                    </>
                )}
            </Message>
        );
    } else if (showCaravanSpinOffMessage) {
        content = (
            <Message theme="warning">
                <p
                    dangerouslySetInnerHTML={{
                        __html: message
                    }}
                />
            </Message>
        );
    } else {
        content = (
            <Message
                theme="warning"
                title={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(title)
                        }}
                    />
                }
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(message)
                    }}
                />
            </Message>
        );
    }

    return <>{content}</>;
};

export default SpinOffMessage;
